import { DYNAMIC_CLIENT_AVERAGE_BASKET_CATMAN_KPIS, DYNAMIC_CLIENT_AVERAGE_BASKET_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_AVERAGE_BASKET_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_AVERAGE_BASKET_KPI_MAPPING } from './constants/averageBasket.kpis.js';
import { DYNAMIC_CLIENT_DIMENSION, DYNAMIC_CLIENT_DIMENSIONS_CATMAN_KPIS, DYNAMIC_CLIENT_DIMENSIONS_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_DIMENSIONS_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_DIMENSIONS_KPI_MAPPING } from './constants/dimensions.kpis.js';
import { DYNAMIC_CLIENT_FREQUENCY_CATMAN_KPIS, DYNAMIC_CLIENT_FREQUENCY_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_FREQUENCY_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_FREQUENCY_KPI_MAPPING } from './constants/frequency.kpis.js';
import { DYNAMIC_CLIENT_NB_CARDHOLDERS_CATMAN_KPIS, DYNAMIC_CLIENT_NB_CARDHOLDERS_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_NB_CARDHOLDERS_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_NB_CARDHOLDERS_KPI_MAPPING } from './constants/nbCardholders.kpis.js';
import { DYNAMIC_CLIENT_NB_TRANSACTIONS_CATMAN_KPIS, DYNAMIC_CLIENT_NB_TRANSACTIONS_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_NB_TRANSACTIONS_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_NB_TRANSACTIONS_KPI_MAPPING } from './constants/nbTransactions.kpis.js';
import { DYNAMIC_CLIENT_SALES_AMOUNT_CATMAN_KPIS, DYNAMIC_CLIENT_SALES_AMOUNT_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_SALES_AMOUNT_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_SALES_AMOUNT_KPI_MAPPING } from './constants/salesAmount.kpis.js';
import { DYNAMIC_CLIENT_SALES_BY_CUSTOMER_CATMAN_KPIS, DYNAMIC_CLIENT_SALES_BY_CUSTOMER_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_SALES_BY_CUSTOMER_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_SALES_BY_CUSTOMER_KPI_MAPPING } from './constants/salesByCustomer.kpis.js';
import { DYNAMIC_CLIENT_SALES_QUANTITY_CATMAN_KPIS, DYNAMIC_CLIENT_SALES_QUANTITY_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_SALES_QUANTITY_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_SALES_QUANTITY_KPI_MAPPING } from './constants/salesQuantity.kpis.js';
export { DYNAMIC_CLIENT_DIMENSION };
export const DYNAMIC_CLIENT_CATMAN_KPIS = [
    ...DYNAMIC_CLIENT_SALES_AMOUNT_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_SALES_QUANTITY_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_NB_CARDHOLDERS_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_NB_TRANSACTIONS_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_AVERAGE_BASKET_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_FREQUENCY_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_SALES_BY_CUSTOMER_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_DIMENSIONS_CATMAN_KPIS
];
export const DYNAMIC_CLIENT_KPI_DISPLAY_NAME = [
    ...DYNAMIC_CLIENT_SALES_AMOUNT_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_SALES_QUANTITY_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_NB_CARDHOLDERS_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_NB_TRANSACTIONS_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_AVERAGE_BASKET_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_FREQUENCY_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_SALES_BY_CUSTOMER_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_DIMENSIONS_KPI_DISPLAY_NAME
];
export const DYNAMIC_CLIENT_KPI_MAPPING = {
    ...DYNAMIC_CLIENT_SALES_AMOUNT_KPI_MAPPING,
    ...DYNAMIC_CLIENT_SALES_QUANTITY_KPI_MAPPING,
    ...DYNAMIC_CLIENT_NB_CARDHOLDERS_KPI_MAPPING,
    ...DYNAMIC_CLIENT_NB_TRANSACTIONS_KPI_MAPPING,
    ...DYNAMIC_CLIENT_AVERAGE_BASKET_KPI_MAPPING,
    ...DYNAMIC_CLIENT_FREQUENCY_KPI_MAPPING,
    ...DYNAMIC_CLIENT_SALES_BY_CUSTOMER_KPI_MAPPING,
    ...DYNAMIC_CLIENT_DIMENSIONS_KPI_MAPPING
};
export const DYNAMIC_CLIENT_DATA_TABLE_KPI_DISPLAY_NAME = [
    ...DYNAMIC_CLIENT_SALES_AMOUNT_DATA_TABLE_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_SALES_QUANTITY_DATA_TABLE_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_NB_CARDHOLDERS_DATA_TABLE_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_NB_TRANSACTIONS_DATA_TABLE_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_AVERAGE_BASKET_DATA_TABLE_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_FREQUENCY_DATA_TABLE_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_SALES_BY_CUSTOMER_DATA_TABLE_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_DIMENSIONS_DATA_TABLE_KPI_DISPLAY_NAME
];
export * from './constants/dynamicClientDecomposition.kpis.js';
export * from './constants/dynamicClientDecompositionTable.kpis.js';
export * from './constants/dynamicClientDynamics.kpis.js';
export * from './constants/dynamicClientEvolution.kpis.js';
//# sourceMappingURL=index.js.map